export default __webpack_public_path__ + "static/media/Doctor.4706e7ea.png";